import { defineWebModule } from '@portal/web-sdk';
import { manifest } from '../manifest.js';
import { en, vi } from './translations.js';

export const tasksWebModule = defineWebModule({
  manifest,
  translations: { vi, en },
  routes: [
    { path: '/tasks', component: () => import('./pages/MyTasksPage.js') },
    { path: '/tasks/projects', component: () => import('./pages/ProjectsPage.js') },
    { path: '/tasks/projects/$projectId', component: () => import('./pages/ProjectPage.js') },
  ],
  widgets: {
    'tasks.mine': () => import('./MyTasksWidget.js'),
  },
});
